import Blockly from 'blockly'
import 'blockly/python'

Blockly.Blocks['machine_ifzero_lcd_char'] = {
  init: function () {
    this.setPreviousStatement(true)
    this.setNextStatement(true)
    this.setStyle('display_blocks')
    this.setInputsInline(true)
    this.appendDummyInput().appendField(
      new Blockly.FieldImage('https://i.ibb.co/kByzBzq/ifkit.jpg', 30, 30, '*')
    )
    this.appendValueInput('CHAR_ID').appendField(
      Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_CHAR_1
    )
    this.appendDummyInput().appendField(
      Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_CHAR_2
    )
    this.appendDummyInput('ROW_LINEBREAK').appendField(
      Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_CHAR_3
    )
    this.appendDummyInput('ROW_LINEBREAK').appendField(
      '    0     1     2     3     4'
    )
    for (let x = 0; x < 8; x++) {
      let input = this.appendDummyInput('ROW_LINEBREAK')
      for (let y = 0; y < 5; y++) {
        if (y === 0) input.appendField(x.toString())
        else input.appendField(' ')
        input.appendField(new Blockly.FieldCheckbox('FALSE'), `LCD${x}${y}`)
      }
    }
    this.setTooltip(Blockly.Msg.CUSTOM_MACHINE_IFZERO_LCD_CHAR_TOOLTIP)
  }
}

Blockly.Python['machine_ifzero_lcd_char'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'

  let charId = Blockly.Python.valueToCode(
    block,
    'CHAR_ID',
    Blockly.Python.ORDER_ATOMIC
  )
  charId = charId ? charId : 0
  let arr = []
  for (let x = 0; x < 8; ++x) {
    let c = 0
    for (let y = 0; y < 5; ++y) {
      c = c << 1
      if (block.getFieldValue(`LCD${x}${y}`) === 'TRUE') c |= 1
      else c |= 0
    }
    arr.push(c)
  }
  const charDef = `ifzero_lcd_char_${charId}`
  if (!Blockly.Python.definitions_[charDef])
    Blockly.Python.definitions_[
      charDef
    ] = `ifzero.lcdCreateChar(${charId}, bytearray([${arr}]))`

  let code = `ifzero.lcdChar(${charId})\n`
  return code
}
